import React from "react";
import DataGridView from '../../Components/DataGridView/DataGridView';
import Http from "../../Api/http";
import ProgressSpinner from '../../Components/ProgressSpinner'
import { FaFlag } from 'react-icons/fa'
import Messages from '../../Components/Messages';
import Util from '../../Util'
import Button from '../../Components/Button';
import Card from "../../Components/Card";
import SiteMap from "../../Components/SiteMap";
import SCC from "../ScreenCommonCode";
import { Accordion, AccordionTab } from "primereact/accordion";
import Input from "../../Components/Input";
import Dropdown from "../../Components/Dropdown";
import Checkbox from "../../Components/Checkbox";
import ButtonsBarLookupList from "../../Components/ButtonsBarLookupList";
import LateSettings from "../SystemSettings/LateSettings";
import MultiSelect from "../../Components/MultiSelect";
import Calendar from "../../Components/Calendar";
import AdditionalFilters from "../AdditionalFilters/AdditionalFilters";
import * as wjcCore from '@grapecity/wijmo';
import Print from "../../Print";

const $ = window.$;

export default class SpecialLeavesBalancesProcess extends React.Component {
    constructor(props) {
        super(props);
        this.nowDate = new Date();
        this.processTypesList = [
            { id: 1, name: $.strings.specialLeavesBalancesProcess.fromVacationBalance },
            { id: 2, name: $.strings.specialLeavesBalancesProcess.fromOverTimeBalance },
            { id: 3, name: $.strings.specialLeavesBalancesProcess.deductionFromSalary },
        ]
        this.discountTypesList = [
            { id: 1, name: $.strings.specialLeavesBalancesProcess.allBalance },
            { id: 2, name: $.strings.specialLeavesBalancesProcess.daysOnly }
        ]
        this.state = {
            loading: true,
            pageInfo: this.setPageInfo(),
            firstExecution: false,
            sectionsList: [],
            employeesList: [],
            data: [],
            dataObject: {
                section: [],
                employees: [],
                date: this.nowDate,
                processType: this.processTypesList[0],
                discountType: this.discountTypesList[0],
                checkHaveTrans: false,
                transDate: this.nowDate,
                additionalFiltersObj: undefined
            },
            isDesktop: true
        };
    }

    componentDidMount = async () => {
        // if (!$.license.HR_Module) {
        //     Util.goTo('/License');
        //     return;
        // }
        // if (!Util.checkISHR() || !Util.checkRights(167)) {
        //     Util.goTo('/Access');
        //     return;
        // }

        let _isDesktop = window.innerWidth > 1250
        let sectionsPromise = this.getSections();
        let employeesPromise = this.getEmployeesList();

        let sectionsList = await sectionsPromise;
        let employeesList = await employeesPromise;

        let dataTemp = [];//await this.onRefresh(true);
        this.setState({
            sectionsList: sectionsList, employeesList: employeesList,
            data: dataTemp, loading: false, isDesktop: _isDesktop,
            dataObject: { ...this.state.dataObject }
        });
    }

    handleUserInput = (e) => {
        const name = e.target.id;
        const value = e.target.value;
        this.setState({ dataObject: { ...this.state.dataObject, [name]: value } });
    }

    handleMultiSelect = (e) => {
        const name = e.target.id;
        const value = e.target.value;
        this.setState({ dataObject: { ...this.state.dataObject, [name]: value } });
    }

    render() {
        const gridStyle = { minHeight: '40vh' }
        let siteMapItems = [
            { label: $.strings.links.reports.menu },
            { label: this.state.pageInfo.title }
        ];
        const siteMapHome = { icon: 'pi pi-home', url: "/" }
        return (
            <div ref={e => this.divMain = e} >
                <ProgressSpinner loading={this.state.loading} />
                {/* <LateSettings ref={e => this.dlgLateSettings = e} /> */}
                <Card>
                    <SiteMap model={siteMapItems} home={siteMapHome} />
                    <ButtonsBarLookupList onRefresh={e => this.onRefresh(false)} onExcelExport={this.excelExport} onPrint={this.print} />

                    <Messages innerRef={(el) => this.messages = el} />
                    <LateSettings ref={e => this.dlgLateSettings = e} />
                    <AdditionalFilters ref={e => this.dlgAdditionalFilters = e} onSuccess={this.onAdditionalFiltersSuccess} />
                </Card>
                <Accordion multiple activeIndex={[0]}>
                    <AccordionTab header={$.strings.filterCaption}>
                        <div className="p-grid">
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                <MultiSelect
                                    id="section"
                                    innerRef={e => this.drpSection = e}
                                    value={this.state.dataObject.section}
                                    options={this.state.sectionsList}
                                    caption={$.strings.specialLeavesBalancesProcess.section}
                                    onChange={(e) => this.handleUserInput(e)}
                                    optionLabel="Name"
                                    display="chip"
                                    maxSelectedLabels="2"
                                    filter={true}
                                />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                <MultiSelect
                                    id="employees"
                                    value={this.state.dataObject.employees}
                                    options={this.state.employeesList}
                                    caption={$.strings.specialLeavesBalancesProcess.employee}
                                    onChange={this.handleMultiSelect}
                                    optionLabel="name"
                                    display="chip"
                                    maxSelectedLabels="2"
                                    showSelectAll={false}
                                    filter
                                />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                <Calendar
                                    id="date"
                                    innerRef={(el) => this.dtpFromDate = el}
                                    value={this.state.dataObject.date}
                                    caption={$.strings.specialLeavesBalancesProcess.date}
                                    onChange={this.handleUserInput}
                                    readOnlyInput={true}
                                    readOnly={true}
                                />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12" style={{ alignSelf: 'flex-end', marginBottom: '5px' }}>
                                <Button label={$.strings.additionalFilters.title} className={this.state.dataObject.additionalFiltersObj ? 'p-button-warning' : ''}
                                    onClick={e => this.dlgAdditionalFilters.show(this.state.dataObject.additionalFiltersObj)} />
                                <Button label="" icon="pi pi-filter-slash" visible={this.state.dataObject.additionalFiltersObj} tooltip={$.strings.additionalFilters.clearFilters}
                                    onClick={e => this.setState({ dataObject: { ...this.state.dataObject, additionalFiltersObj: undefined } })}
                                />
                            </div>
                        </div>

                    </AccordionTab>
                    <AccordionTab header={$.strings.saveData}>
                        <div className="p-grid">
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                <Dropdown
                                    id="processType"
                                    value={this.state.dataObject.processType}
                                    options={this.processTypesList}
                                    caption={$.strings.specialLeavesBalancesProcess.processType}
                                    onChange={this.handleUserInput}
                                    optionLabel="name"
                                />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                <Dropdown
                                    id="discountType"
                                    value={this.state.dataObject.discountType}
                                    options={this.discountTypesList}
                                    caption={$.strings.specialLeavesBalancesProcess.discountType}
                                    onChange={this.handleUserInput}
                                    optionLabel="name"
                                />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                                <Calendar
                                    id="transDate"
                                    value={this.state.dataObject.transDate}
                                    caption={$.strings.specialLeavesBalancesProcess.transDate}
                                    onChange={this.handleUserInput}
                                    readOnlyInput={true}
                                    readOnly={true}
                                />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end', marginBottom: '5px' }}>
                                <Checkbox id="checkHaveTrans" caption={$.strings.specialLeavesBalancesProcess.checkHaveTrans}
                                    onChange={e => this.setState({ dataObject: { ...this.state.dataObject, checkHaveTrans: e.checked } })}
                                    checked={this.state.dataObject.checkHaveTrans} />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                                <Button label={$.strings.firstExecution} icon="pi pi-check" onClick={this.onFirstExecution}
                                    disabled={!this.state.data || this.state.data.length <= 0} />
                            </div>
                            <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                                <Button label={$.strings.saveData} icon="pi pi-save" className="p-button-success" onClick={this.onSaveData}
                                    disabled={!this.state.data || this.state.data.length <= 0 || !this.state.firstExecution} />
                            </div>
                        </div>
                    </AccordionTab>

                </Accordion>
                <Card>
                    <DataGridView
                        style={gridStyle}
                        ref={e => this.gridData = e}
                        isReport={true}
                        scheme={this.getScheme()}
                        exportFileName={this.state.pageInfo.title}
                        dataSource={this.state.data}
                        defaultRowHeight={45}
                    />
                </Card>
            </div >
        );
    }
    getError(item, propName, parsing = false) {
        switch (propName) {
            default: {
                break;
            }
        }
        return null;
    }
    onFirstExecution = () => {
        let dataTemp = this.state.data;
        if (dataTemp) {
            let data = dataTemp.filter(e => e.Selected === true);

            this.setState({ data: data, firstExecution: true });
        }
    }
    onSaveData = async () => {
        if (!this.state.dataObject.transDate) {
            Util.showErrorMsg(this.messages, $.strings.specialLeavesBalancesProcess.transDateError)
            return;
        }
        if (!this.state.data || this.state.data.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.specialLeavesBalancesProcess.dataError)
            return;
        }
        this.setState({ loading: true });
        let success = false;
        let dataTemp = [];
        const params = {
            TransDate: this.state.dataObject.transDate,
            CheckHaveTrans: this.state.dataObject.checkHaveTrans,
            dt_SpecialLeave: this.state.data,
            ProcessType: this.state.dataObject.processType.id,
            DiscountType: this.state.dataObject.discountType.id,
            UserId: localStorage.getItem("useridHR") + ""
        }

        let res = await Http.postMultipartAxios(Http.actions.Reports.urlSaveSpecialLeave, params, this.state.pageInfo.pageId);
        if (res.status === 200) {
            if (res.data && res.data.success) {
                success = res.data.success;
                dataTemp = res.data.dt_SpecialLeave;
                if (success) {
                    Util.showSuccessMsg(this.messages);
                }
            }
            else {
                let msg = $.strings.operationFailed;
                if (res.data.errorText && res.data.errorText.length > 0) {
                    msg = res.data.errorText;
                    Util.showErrorMsg(this.messages, msg, false);
                }
            }
        }
        else {
            let msg = $.strings.operationFailed;
            if (res.data.errorText && res.data.errorText.length > 0) {
                msg = res.data.errorText;
                Util.showErrorMsg(this.messages, msg, false);
            }
        }
        this.setState({ data: dataTemp, loading: false })
    }

    setPageInfo = () => {
        let pageId
        let title = $.strings.specialLeavesBalancesProcess.title

        return { pageId: pageId, title: title };
    };

    onAdditionalFiltersSuccess = (obj) => {
        if (obj) {

            this.setState({ dataObject: { ...this.state.dataObject, additionalFiltersObj: obj } })
        }
    }

    onClose = async (e) => {
        this.onRefresh();
        this.setState({ dlgSearchVisible: false });
    };


    btnRefresh = e => {
        this.setState({ data: this.onRefresh(false) });
    };

    excelExport = () => {
        this.gridData.exportCSV();
    }

    print = () => {

        if (!this.state.data || this.state.data.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }

        let obj = Print.getReportPrintObject(this.state.pageInfo.title, this.gridData, this.state.data);
        if (!obj || !obj.data || obj.data.columns.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }
        let listOfFilters = [];
        if (this.printFilters) {
            let dateFilter = "";

            if (this.printFilters.section && this.printFilters.section.length === 1) {
                let sectionFilter = "";
                sectionFilter += " " + $.strings.specialLeavesBalancesProcess.section + ": ";
                for (let index = 0; index < this.printFilters.section.length; index++) {
                    let name = this.printFilters.section[index].Name;
                    if (index > 0)
                        sectionFilter += ", ";
                    sectionFilter += " " + name;
                }
                if (sectionFilter !== "")
                    listOfFilters.push(sectionFilter);
            }

            if (this.printFilters.employees && this.printFilters.employees.length === 1) {
                let employeesFilter = "";
                employeesFilter += " " + $.strings.specialLeavesBalancesProcess.employee + ": ";
                for (let index = 0; index < this.printFilters.employees.length; index++) {
                    let name = this.printFilters.employees[index].name;
                    if (index > 0)
                        employeesFilter += ", ";
                    employeesFilter += " " + name;
                }
                if (employeesFilter !== "")
                    listOfFilters.push(employeesFilter);
            }

            // Date Filter
            if (this.printFilters.date) {
                dateFilter = $.strings.specialLeavesBalancesProcess.date + ": " + Util.getDateFormat(this.printFilters.date);
            }
            if (dateFilter !== "")
                listOfFilters.push(dateFilter)

        }
        obj.headers = Print.getPrintingHeaderStrings(listOfFilters, obj.headers)

        Print.doPrintReport(obj);
    };

    onRefresh = async (fromLoad) => {
        let dataTemp = [];
        if (!this.state.dataObject.date) {
            Util.showErrorMsg(this.messages, $.strings.specialLeavesBalancesProcess.fromDateError)
            return;
        }

        this.setState({ loading: true, firstExecution: false, data: [] });

        let generalFillter = {};

        if (this.state.dataObject.section) {
            let sectionsList = []
            for (let index = 0; index < this.state.dataObject.section.length; index++) {
                sectionsList.push(this.state.dataObject.section[index].Code)
            }
            generalFillter.SectionList = sectionsList;
        }
        if (this.state.dataObject.employees) {
            let empList = [];
            for (let index = 0; index < this.state.dataObject.employees.length; index++) {
                empList.push(this.state.dataObject.employees[index].code)
            }
            generalFillter.EmpList = empList;
        }
        Util.fillAditionalsFilters(this.state.dataObject.additionalFiltersObj, generalFillter);

        const params = {
            FromDate: this.state.dataObject.date,
            GeneralFillter: generalFillter,
        }

        let res = await Http.postMultipartAxios(Http.actions.Reports.urlProcessSpecialLeaveReport, params, this.state.pageInfo.pageId);

        if (res.status === 200) {
            dataTemp = res.data.dtReturn;
            if (dataTemp && dataTemp.length > 0) {
                dataTemp.forEach(element => {
                    element.Selected = true;
                });
            }
        }

        if (fromLoad) {
            return dataTemp;
        }
        else {
            this.setState({ data: dataTemp, loading: false }, () => this.printFilters = this.state.dataObject)
        }
    }

    getSections = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            empCode: localStorage.getItem("useridHR")
        }
        let res = await Http.getJsonAxios(Http.actions.Sections.urlGetSections, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
            if (dataTemp) {
                dataTemp.splice(0, 1);
            }
        }
        return dataTemp
    }
    getEmployeesList = async () => {
        let dataTemp = []
        let obj = {
            userId: localStorage.getItem('useridHR'),
            searchValue: !this.state.empCodeOrName || this.state.empCodeOrName.length <= 0 ? '' : this.state.empCodeOrName,
            isHr: Util.checkISHR(),
            getEmpStatus: this.state.getEmpStatus ? this.state.getEmpStatus : false,
            section: this.state.section && this.state.section.ID >= 0 ? this.state.section.ID : "-1",
            empStatus: this.state.empStatus && this.state.empStatus.id >= 0 ? this.state.empStatus.id : -1,
        }

        let res = await Http.getJsonAxios(Http.actions.Employee.urlGetEmployees, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.empObjList;

        }
        return dataTemp
    }

    getScheme = () => {
        let scheme = {
            name: "specialLeaveBalancesScheme_Table",
            filter: true,
            showFooter: true,
            sortable: true,
            allowGrouping: false,
            responsiveColumnIndex: 3,
            columns: [
                { name: 'RowNumber', header: '#', width: 60, dataType: 'Number', aggregate: 'Cnt', columnWidth: '1' },
                {
                    name: 'Selected', header: $.strings.specialLeavesBalancesProcess.select, width: 80,
                    visibleInColumnChooser: false, visible: false
                },
                { name: 'Code', header: $.strings.specialLeavesBalancesProcess.code, width: 80, columnWidth: '2' },
                { name: 'Name', header: $.strings.specialLeavesBalancesProcess.empName, width: '*', minWidth: 150, columnWidth: '*' },
                {
                    name: 'Sections', header: $.strings.specialLeavesBalancesProcess.section, width: 120, dataType: 'Object', customAggregate: true,
                    visible: false, columnWidth: '3'
                },
                { name: 'Classification', header: $.strings.specialLeavesBalancesProcess.classification, width: 120, visible: false, columnWidth: '2' },
                { name: 'LeaveBalance', header: $.strings.specialLeavesBalancesProcess.speicalLeaveBalance, width: 150, columnWidth: '3' },
                { name: 'LeaveDiscountBalance', header: $.strings.specialLeavesBalancesProcess.balanceForDiscount, width: 150, columnWidth: '3' },
                {
                    name: 'VacationBalance', header: $.strings.specialLeavesBalancesProcess.annualVacationBalance, width: 200, dataType: 'Object',
                    customAggregate: true, columnWidth: '3'
                },
                { name: 'PeriodBalance', header: $.strings.specialLeavesBalancesProcess.periodBalance, width: 150, visible: false, visibleInColumnChooser: false, },
                { name: 'OverTimeBalance', header: $.strings.specialLeavesBalancesProcess.overTimeBalance, width: 200, aggregate: 'Sum', columnWidth: '3' },
                { name: 'Notes', header: $.strings.specialLeavesBalancesProcess.notes, minWidth: 200, columnWidth: '3' }
            ]
        }
        return scheme;
    }
}